// Typelizer digest 2c6d29de3915d12a60ccb6c6ad7e5757
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** POST /incoming_emails/:id/extract_text */
  extractText: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/incoming_emails/:id/extract_text', params, options),
    method: 'post',
  }),

  /** POST /incoming_emails/:id/process_attachments */
  processAttachments: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/incoming_emails/:id/process_attachments', params, options),
    method: 'post',
  }),

  /** GET /incoming_emails */
  index: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/incoming_emails', {}, options),
    method: 'get',
  }),

  /** GET /incoming_emails/:id */
  show: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/incoming_emails/:id', params, options),
    method: 'get',
  }),
}
